import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id: 'applications',
        title: '',
        translate: 'NAV.APPLICATIONS',
        type: 'group',
        children: [
            {
                id: 'dashboard',
                title: 'Dashboard',
                translate: 'NAV.SAMPLE.TITLE',
                type: 'item',
                icon: 'dashboard',
                url: '/dashboard',
                // badge    : {
                //     title    : '25',
                //     translate: 'NAV.SAMPLE.BADGE',
                //     bg       : '#F44336',
                //     fg       : '#FFFFFF'
                // }
            }, {
                id: 'messages',
                title: 'Chat',
                translate: 'NAV.SAMPLE.TITLE',
                type: 'item',
                icon: 'chat',
                url: '/chat',
                // badge    : {
                //     title    : '25',
                //     translate: 'NAV.SAMPLE.UPLOAD',
                //     bg       : '#F44336',
                //     fg       : '#FFFFFF'
                // }
            }, {
                id: 'users',
                title: 'Users',
                translate: 'NAV.SAMPLE.TITLE',
                type: 'item',
                icon: 'account_circle',
                url: '/users',
                // badge    : {
                //     title    : '25',
                //     translate: 'NAV.SAMPLE.BADGE',
                //     bg       : '#F44336',
                //     fg       : '#FFFFFF'
                // }
            },
            //  {
            //     id: 'businesses',
            //     title: 'Businesses',
            //     translate: 'NAV.SAMPLE.TITLE',
            //     type: 'item',
            //     icon: 'business',
            //     url: '/businesses',
            //     // badge    : {
            //     //     title    : '25',
            //     //     translate: 'NAV.SAMPLE.BADGE',
            //     //     bg       : '#F44336',
            //     //     fg       : '#FFFFFF'
            //     // }
            // },
            {
                id: 'chapters',
                title: 'Chapters',
                translate: 'NAV.SAMPLE.TITLE',
                type: 'item',
                icon: 'location_on',
                url: '/chapters',
                // badge    : {
                //     title    : '25',
                //     translate: 'NAV.SAMPLE.BADGE',
                //     bg       : '#F44336',
                //     fg       : '#FFFFFF'
                // }
            }, {
                id: 'industries',
                title: 'Industries',
                translate: 'NAV.SAMPLE.TITLE',
                type: 'item',
                icon: 'business',
                url: '/industries',
                // badge    : {
                //     title    : '25',
                //     translate: 'NAV.SAMPLE.BADGE',
                //     bg       : '#F44336',
                //     fg       : '#FFFFFF'
                // }
            }, {
                id: 'groups',
                title: 'Groups',
                translate: 'NAV.SAMPLE.TITLE',
                type: 'item',
                icon: 'group',
                url: '/groups',
                // badge    : {
                //     title    : '25',
                //     translate: 'NAV.SAMPLE.BADGE',
                //     bg       : '#F44336',
                //     fg       : '#FFFFFF'
                // }
            }, {
                id: 'analytics',
                title: 'Analytics',
                translate: 'NAV.SAMPLE.TITLE',
                type: 'item',
                icon: 'insert_chart',
                url: '/analytics',
                // badge    : {
                //     title    : '25',
                //     translate: 'NAV.SAMPLE.BADGE',
                //     bg       : '#F44336',
                //     fg       : '#FFFFFF'
                // }
            }
        ]
    }
];
